import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcRequirementReviewProps,

    LoadCcRequirementById,
    LoadCcRequirementState,
    LoadCcRequirementHistory,
    LoadCcRequirementTempAnswers,
    LoadCcRequirementTempAnswerVersions,

    setCcRequirementRequirementDetails,
    setCcRequirementRequirementState,
    setCcRequirementRequirementHistory,
    setCcRequirementTempAnswers,
    setCcRequirementTempAnswerVersions,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"
import AnswerForm from "./form"

interface RequirementAnswerProps extends CcRequirementReviewProps {}

const RequirementAnswer = ({
    requirementId,
    revisionId,
}: RequirementAnswerProps) => {
    const requirement = useSelector((state: StoreType) => state.ccRequirement.requirementDetails)
    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadCcRequirementById(requirementId, project.id).then((res) => {
                dispatch(setCcRequirementRequirementDetails(res))
            }),
            LoadCcRequirementState(requirementId, revisionId).then((res) => {
                dispatch(setCcRequirementRequirementState(res))
            }),
            LoadCcRequirementHistory(requirementId, revisionId).then((res) => {
                dispatch(setCcRequirementRequirementHistory(res))
            }),
            LoadCcRequirementTempAnswers(requirementId, revisionId).then((res) => {
                dispatch(setCcRequirementTempAnswers(res))
            }),
            LoadCcRequirementTempAnswerVersions(requirementId, revisionId).then((res) => {
                dispatch(setCcRequirementTempAnswerVersions(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!requirement) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
                <AnswerForm />
            </PageContent>
        </Container>
    )
}
export default RequirementAnswer
